<template>
  <page>
    <tabs :activeTab="activeTab" :tabs="tabs" :onTabChange="onTabChange" />
  </page>
</template>

<script>
import Page from "@/components/layout/Page";
import Tabs from "@/components/layout/Tabs";
import Orgs from "./Organizations/Organizations.vue";
import SAML from "./SAML/SAML.vue";

export default {
  data() {
    return {
      activeTab: this.$route.params.tab || "organizations",
      tabs: [Orgs, SAML],
    };
  },
  components: {
    Page,
    Tabs,
  },
  methods: {
    onTabChange(tab) {
      this.$router.push(`/enterprise/${tab.name}`, () => {});
    },
  },
};
</script>
